<template>
	<div id="main">
		
			<div class="sku-box store-content ">				
				<!---->
				<div class="gray-box">
					<header class="title-header">
						<h5 class="title">NB控制器</h5>
					</header>
					<div class="item-box">
						
						<shopItem v-for="(item,index) in productsData" :key="index" :itemProduct='item' ></shopItem>
						
					</div>
				</div>
			</div>
		</div>
</template>

<script>
	import productsData from '@/lib/controllersData.js';
	import shopItem from '@/components/item-controller'
	
	export default {
		data(){
			return {productsData};
		},
		components:{
			shopItem
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/pageController.vue